<template>
  <div ref="map" class="map" />
</template>

<script>
import * as loadGoogleMapsApi from 'load-google-maps-api'
import constants from '@/dependencies/constants'
import { GOOGLE_MAPS_KEY } from '~/config/socials'

export default {
  name: 'Map',
  props: {
    markers: {
      type: Array,
      default: () => []
    },
    city: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      customMap: null,
      googleMaps: null,
      minMakersNumber: 2,
      createdMarkers: []
    }
  },
  watch: {
    markers() {
      if (this.googleMaps && this.markers.length) {
        this.placeMarkers(this.googleMaps)
      }
    }
  },
  mounted() {
    loadGoogleMapsApi({
      key: GOOGLE_MAPS_KEY
    })
      .then((googleMaps) => {
        this.googleMaps = googleMaps

        this.customMap = new googleMaps.Map(this.$refs.map, {
          center: {
            lat: 0,
            lng: 0
          },
          zoom: constants.COMMON.INITIAL_ZOOM_LEVEL,
          gestureHandling: 'greedy'
        })

        if (this.markers && this.markers.length) {
          this.placeMarkers(googleMaps)
        }
      })
      .catch((error) => {
        //  eslint-disable-next-line
      console.error(error)
      })
  },
  beforeDestroy() {
    this.createdMarkers.forEach((item) => {
      this.googleMaps.event.clearListeners(item, 'click')
      this.googleMaps.event.clearListeners(item, 'mouseover')
      this.googleMaps.event.clearListeners(item, 'mouseout')
    })
    this.createdMarkers = []
  },
  methods: {
    mapMarker(maps, club) {
      return new maps.Marker({
        position: club.position,
        map: this.customMap,
        icon: this.getMapClubIcon()
      })
    },
    placeMarkers(maps) {
      const bounds = new maps.LatLngBounds()
      const InfoWindow = new maps.InfoWindow({
        content: ''
      })

      if (this.markers.length < this.minMakersNumber) {
        const club = this.markers[0]
        club.position = {
          lat: parseFloat(club.lat),
          lng: parseFloat(club.lng)
        }
        const marker = this.mapMarker(maps, club)
        this.createdMarkers.push(marker)

        marker.addListener('click', () => {
          InfoWindow.setPosition(club.position)
          InfoWindow.setContent(this.infoWindowTemplate(club))
          InfoWindow.open(this.googleMaps, marker)
        })

        this.customMap.setCenter(club.position)
      } else {
        this.markers.map((club) => {
          club.position = {
            lat: parseFloat(club.lat),
            lng: parseFloat(club.lng)
          }
          bounds.extend(club.position)

          const marker = this.mapMarker(maps, club)
          this.createdMarkers.push(marker)

          //  @TODO put in separate function if figure out how to pass
          //  link on InfoWindow
          marker.addListener('click', () => {
            InfoWindow.setPosition(club.position)
            InfoWindow.setContent(this.infoWindowTemplate(club))
            InfoWindow.open(this.googleMaps, marker)
          })

          marker.addListener('mouseover', () => {
            marker.setIcon(this.getMapClubIcon(true))
          })
          marker.addListener('mouseout', () => {
            marker.setIcon(this.getMapClubIcon(false))
          })
        })

        this.customMap.fitBounds(bounds)
        this.customMap.setZoom(constants.COMMON.CITY_ZOOM_LEVEL)
      }
    },
    getMapClubIcon(active = false) {
      return active
        ? require('~/assets/img/club-on-map-orange.png')
        : require('~/assets/img/club-on-map.png')
    },
    infoWindowTemplate(item) {
      return `
            <a
              href="/${this.$i18n.locale}/${this.city}/club/${item.url}"
              class="club-item"
            >
              <div
                class="club-image"
                style="background-image: url(${item.avatar})"
              ></div>
              <div class="club-info">
                <p class="club-name">${item.title}</p>
                <p class="club-address py-1">${item.address}</p>
                <p class="club-trainers mb-1">${this.$t('common.trainers')}: ${
        item.count
      }</p>
              </div>
            </a>
          `
    }
  }
}
</script>

<style scoped lang="scss">
.map {
  width: 100%;
  max-height: 770px;
  height: 75vh;
}
</style>
